import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  fontBolded: {
    fontWeight: 600,
  },
  divider: {
    margin: '20px 0',
  },
  lighterText: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  backButton: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: '1rem',
    textTransform: 'none',
    marginTop: '30px',
    marginBottom: '1rem',
    paddingLeft: '0',
    '& svg': {
      transition: '0.1s ease-in-out',
    },
    '&:focus': {
      padding: '1.25rem',
    },
    '&:hover': {
      color: theme.palette.primary.main,
      '& svg': {
        transform: 'translateX(-4px)',
      },
    },
    '&:active': {
      color: theme.palette.primary.lightest,
    },
  },
}))
